import { Route, Routes, useNavigate } from "react-router-dom";
// import { PermissionName } from '../models/user-security/permission.name';
// import { PermissionCheckType } from '../models/user-security/permission-check-type';
import { validateRequiredPermissions } from "../Utils/permission.manager";
import { useCurrentUser } from "../hooks/user-current-user.hook";
import { HeaderComponent } from "./header.component";
import CategoryList from "../features/category/category.page";
import Dashboard from "../features/home/dashboard.page";
import { LoginPage } from "../features/authentication/login-page";
import { PermissionCheckType } from "../models/user-security/permission-check-type";
import BlockPage from "../features/block/block.page";
import ConstituencyPage from "../features/constituency/constituency.page";
import CorporationZonePage from "../features/corporationzone/corporationzone.page";
import DistrictPage from "../features/district/district.page";
import RoutePage from "../features/route/route.page";
import RouteCityPage from "../features/routecity/routecity.page";
import ZonePage from "../features/zone/zone.page";
import WardPage from "../features/ward/ward.page";
import SessionPage from "../features/session/session.page";
import StatePage from "../features/state/state.page";
import TalukPage from "../features/taluk/taluk.page";
import UnionsPage from "../features/unions/unions.page";
import UserTypePage from "../features/userdetails/userdetails.page";
import VehiclePage from "../features/vehicle/vehicle.page";
import VehicleTransportPage from "../features/vehicletransport/vehicletransport.page";
import SaleTypePage from "../features/saletype/saletype.page";
import VehicleTypePage from "../features/vehicletype/vehicletype.page";
import CategoryPage from "../features/category/category.page";
import MainGroupPage from "../features/maingroup/maingroup.page";
import SubGroupPage from "../features/subgroup/subgroup.page";
import ProductPage from "../features/product/product.page";
import ProductPricePage from "../features/productprice/productprice.page";
import ProductAvailabilityPage from "../features/productavailability/productavailability.page";
import UOMPage from "../features/uom/uom.page";
import CardCustomerPage from "../features/cardcustomer/cardcustomer-page";
import EmployeePage from "../features/employee/employee-page";
import AgentPage from "../features/agent/agent-page";
import DropingPointPage from "../features/dropingpoint/dropingpoint-page";
import ProductTaxPage from "../features/producttax/producttax.page";
//import RouteDroppingPointMapPage from '../features/routedroppingpointmap/routedroppingpointmap.page';
import CompanyDetailsPage from "../features/companydetails/companydetails.page";

import ReportCenter from '../features/reports/report-center';
import { AuthorizeComponent } from './authorize.component';

import { RouteSummaryReport } from '../features/reports/dailyreports/routesummary-report';
import { RouteAbstractReport } from '../features/reports/dailyreports/routeabstract-report';
import { ZoneSummaryReport } from '../features/reports/dailyreports/zonesummary-report';
import { ZoneRoutewiseAbstractReport } from '../features/reports/dailyreports/zoneroutewiseabstract-report';
import { ZoneAbstractReport } from '../features/reports/dailyreports/zoneabstract-report';
import { DailyCashCollectionReport } from '../features/reports/dailyreports/dailycashcollection-report';
import { CitywiseRouteSaleReport } from '../features/reports/dailyreports/citywiseroutesale-report';
import { MonthlyDairySummaryReport } from '../features/reports/monthlyreports/monthlydairysummary-report';
import { SocietyBillReport } from '../features/reports/monthlyreports/societybill-report';
import { OldIndentReport } from '../features/reports/indent/oldindent-report';
import PrepareIndentNewReport from '../features/reports/indent/prepareindentnew-report';
import { OnlinePaymentLogReport } from '../features/reports/onlinepayment/onlinepaymentlog-report';
import { AgentTransactionReport } from '../features/reports/onlinepayment/agenttransaction-report';
import { PaymentReport } from '../features/reports/onlinepayment/payment-report';
import { WalletLogReport } from '../features/reports/onlinepayment/walletlog-report';
import { DateWiseComparativeReport } from '../features/reports/analysereport/datewisecomparative-report';
import { MonthWiseComparativeReport } from '../features/reports/analysereport/monthwisecomparative-report';
import { CommissionReport } from "../features/reports/monthlyreports/commissionreport-report";
//import { DeliveryNoteReport } from '../features/reports/indent/deliverynote-report';

import AgentEntry from '../features/agent/agent-entry';
import AgentOrderNewPage from "../features/transaction/agent-order/agentordernew.page";
import AgentOrderPage from "../features/transaction/agent-order/agentorder.page";
import CardOrderPage from "../features/transaction/card-order/cardorder.page";
import CardOrderEntryPage from "../features/transaction/card-order/cardorder-entry";
import IndentMain from "../features/indents/indent.component";
import IndentPreparation from "../features/indents/indent.component";
import { MilkAcknowledgmentReport } from "../features/reports/dailyreports/milkacknowlegement-report";
import EmployeeFreeMilkPage from "../features/transaction/employeefreemilk/employeefreemilk.page";
import CounterPage from "../features/counter/counter.page";
import UserDetailsPage from "../features/userdetails/userdetails.page";
import { FermentedMilkGSTBillReport } from "../features/reports/monthlyreports/fermentedmilkgstbill-report";
import { AgentMonthlyReport } from "../features/reports/monthlyreports/agentmonthlyreport-report";
import { YearWiseComparativeReport } from "../features/reports/analysereport/yearwisecomparative-report";
import { DailyCounterSaleReport } from "../features/reports/order and collection/dailycountersale-report";
import { DailyCounterSalesSummaryReport } from "../features/reports/order and collection/dailycountersalesummary-report";
import { UnionWiseSummaryReport } from "../features/reports/dailyreports/unionwisesummary-report";
import { InstitutionBillReport } from "../features/reports/monthlyreports/institutionbill-report";
import { FermentedMilkJSONReport } from "../features/reports/monthlyreports/fermentedmilkjson-report";
import MonthlyCounterSaleSummaryReport from "../features/reports/order and collection/monthlycountersalesummary-report";
import { MonthlyInstitutionBillAbstractReport } from "../features/reports/monthlyreports/monthlyinstitutionbillabstract-report";
import CustomerPage from "../features/customer/customer.page";
import PaymentGatewayPage from "../features/paymentgateway/paymentgateway.page";
import ProductInvoicePage from "../features/transaction/product-invoice/productinvoice.page";
import ProductInvoiceEntryPage from "../features/transaction/product-invoice/productinvoice-entry";
import AgentLiterOrderPage from "../features/transaction/agent-literorder/agentliterorder.page";
import ProductInvoiceEntryPageNew from "../features/transaction/product-invoice/productinvoicenew-entry";
import ProductInvoiceHistoryPage from "../features/transaction/product-invoice/productinvoicehistory.page";
import AgentOrderEntryPage from "../features/transaction/agent-order/agentorder-entry";
import SideBarMainComponent from "./sidenavbar.main.component";




interface IMenuType {
  menuType: string;
}
export function MainRoutes(props: IMenuType) {
  const { currentPermissions } = useCurrentUser();
  return (
    <>
      {/* <HeaderComponent /> */}
      <SideBarMainComponent />
      <Routes>
        <Route path="/Dashboard" element={<Dashboard></Dashboard>} />
        <Route path="/home" element={<Dashboard></Dashboard>} />
        <Route path="/Users" element={<UserDetailsPage />} />

        {/* Masters */}
        <Route path="/Block" element={<BlockPage />} />
        <Route path="/CorporationZone" element={<CorporationZonePage />} />
        <Route path="/Constituency" element={<ConstituencyPage />} />
        <Route path="/Category" element={<CategoryPage />} />
        <Route path="/District" element={<DistrictPage />} />
        <Route path="/RouteCity" element={<RouteCityPage />} />
        <Route path="/Route" element={<RoutePage />} />
        <Route path="/SaleType" element={<SaleTypePage />} />
        {/* <Route path="/RouteDroppingPointMap" element={<RouteDroppingPointMapPage />} /> */}
        <Route path="/SaleType" element={<SaleTypePage />} />
        {/* //<Route path="/Session" element={<SessionPage />} /> */}
        <Route path="/State" element={<StatePage />} />
        <Route path="/Taluk" element={<TalukPage />} />
        <Route path="/Unions" element={<UnionsPage />} />
        <Route path="/Counter" element={<CounterPage />} />
        <Route path="/UserType" element={<UserTypePage />} />
        <Route path="/Vehicle" element={<VehiclePage />} />
        <Route path="/VehicleTransport" element={<VehicleTransportPage />} />
        <Route path="/VehicleType" element={<VehicleTypePage />} />
        <Route path="/Ward" element={<WardPage />} />
        <Route path="/Zone" element={<ZonePage />} />
        <Route path="/PaymentGateway" element={<PaymentGatewayPage />} />

        {/* Product */}
        <Route path="/MainGroup" element={<MainGroupPage />} />
        <Route path="/SubGroup" element={<SubGroupPage />} />
        <Route path="/Product" element={<ProductPage />} />
        <Route path="/ProductPrice" element={<ProductPricePage />} />
        <Route
          path="/ProductAvailability"
          element={<ProductAvailabilityPage />}
        />
        <Route path="/UOM" element={<UOMPage />} />
        <Route path="/ProductTax" element={<ProductTaxPage />} />

        {/* Party */}
        <Route path="/Consumer" element={<CardCustomerPage />} />
        <Route path="/DropingPoint" element={<DropingPointPage />} />
        <Route path="/Customer" element={<CustomerPage />} />
        <Route path="/Employee" element={<EmployeePage />} />
        <Route path="/Agent" element={<AgentPage />} />
        <Route path="/Customer" element={<CustomerPage />} />

        {/* Orders */}
        <Route path="/AgentOrders" element={<AgentOrderPage />} />
        {/* <Route path="/AgentOrdersEntry" element={<AgentOrderNewPage />} /> */}
        {/*  <Route path="/AgentOrdersEntry" element={<AgentOrderEntryPage />} /> */}

        <Route path="/ConsumerOrders" element={<CardOrderPage />} />
        {/*  <Route path="/ConsumerOrdersEntry" element={<CardOrderEntryPage />} /> */}
        <Route path="/EmployeeFreeMilk" element={<EmployeeFreeMilkPage />} />

        {/*         <Route path="/AgentOrders(Liter)" element={<AgentLiterOrderPage />} /> */}
        {/*   <Route path="/AgentLiterOrdersEntry" element={<AgentLiterOrderEntry />} /> */}

        {/*   <Route path="/ProductInvoiceEntry" element={<ProductInvoiceEntryPage />} /> */}
        <Route path="/ProductInvoice" element={<ProductInvoicePage />} />
        {/*  <Route path="/ProductInvoiceEntry" element={<ProductInvoiceEntryPageNew />} /> */}
        {/* <Route path="/ProductInvoiceHistoryPage" element={<ProductInvoiceHistoryPage />} /> */}
        {/* <Route path="/ProductInvoiceHistoryPage" element={<ProductInvoiceHistoryPage setActivePage={function (page: "list" | "entry"): void {
          throw new Error("Function not implemented.");
        }} />} /> */}


        {/* Reports */}
        <Route path="/ReportCenter" element={<ReportCenter />} />
        {/* <Route path="/ScheduledReport"  element={<ScheduledReport/>} ></Route> */}
        <Route path="/OnlinePaymentLogReport" element={<OnlinePaymentLogReport />} ></Route>
        <Route path="/AgentTransactionReport" element={<AgentTransactionReport />} ></Route>
        <Route path="/PaymentReport" element={<PaymentReport />} ></Route>
        <Route path="/WalletLog" element={<WalletLogReport />} ></Route>
        <Route path="/DateWiseComparative" element={<DateWiseComparativeReport />} ></Route>
        <Route path="/MonthWiseComparative" element={<MonthWiseComparativeReport />} ></Route>
        <Route path="/YearWiseComparative" element={<YearWiseComparativeReport />} ></Route>
        <Route path="/MonthlyCounterSaleSummary" element={<MonthlyCounterSaleSummaryReport />} ></Route>
        <Route path="/DailyCounterSale" element={<DailyCounterSaleReport />} ></Route>
        <Route path="/DailyCounterSaleSummary" element={<DailyCounterSalesSummaryReport />} ></Route>

        {/* Sales */}
        {/*   <Route path="/AgentOrders" element={<AgentOrderPage/>} /> */}
        {/*     <Route path="/AgentOrders" element={<AgentOrderNewPage />} /> */}


        <Route path="/ReportCenter" element={<ReportCenter />} />


        <Route path="/OldIndent" element={<OldIndentReport />} ></Route>
        {/* <Route path="/PrepareIndent" element={<PrepareIndentReport />} ></Route> */}
        <Route path="/PrepareIndent" element={<PrepareIndentNewReport />} ></Route>
        <Route path="/IndentPreparation" element={<PrepareIndentNewReport />} ></Route>


        <Route path="/RouteSummary" element={<RouteSummaryReport />} ></Route>
        <Route path="/RouteAbstract" element={<RouteAbstractReport />} ></Route>
        <Route path="/ZoneSummary" element={<ZoneSummaryReport />} ></Route>
        <Route path="/ZoneRoutewiseAbstract" element={<ZoneRoutewiseAbstractReport />} ></Route>
        <Route path="/MilkAcknowledgment" element={<MilkAcknowledgmentReport />} ></Route>
        <Route path="/UnionwiseSummary" element={<UnionWiseSummaryReport />} ></Route>
        <Route path="/ZoneAbstract" element={<ZoneAbstractReport />} ></Route>
        <Route path="/DailyCashCollection" element={<DailyCashCollectionReport />} ></Route>
        <Route path="/CitywiseRouteSale" element={<CitywiseRouteSaleReport />} ></Route>
        <Route path="/IndentPreparation" element={<IndentPreparation />} />

        <Route path="/MonthlyDairySummary" element={<MonthlyDairySummaryReport />} ></Route>
        <Route path="/CommissionReport" element={<CommissionReport />} ></Route>
        <Route path="/MonthlyInstitutionBillAbstract" element={<MonthlyInstitutionBillAbstractReport />} ></Route>
        <Route path="/InstitutionBill" element={<InstitutionBillReport />} ></Route>
        <Route path="/SocietyBill" element={<SocietyBillReport />} ></Route>
        <Route path="/AgentMonthlyReport" element={<AgentMonthlyReport />} ></Route>
        <Route path="/FermentedMilkGSTBill" element={<FermentedMilkGSTBillReport />} ></Route>
        <Route path="/FermentedMilkJSON" element={<FermentedMilkJSONReport />} ></Route>


        <Route path="/OnlinePaymentLogReport" element={<OnlinePaymentLogReport />} ></Route>
        <Route path="/AgentTransactionReport" element={<AgentTransactionReport />} ></Route>
        <Route path="/PaymentReport" element={<PaymentReport />} ></Route>
        <Route path="/WalletLog" element={<WalletLogReport />} ></Route>
        <Route path="/DateWiseComparative" element={<DateWiseComparativeReport />} ></Route>
        <Route path="/MonthWiseComparative" element={<MonthWiseComparativeReport />} ></Route>






      </Routes>
    </>
  );

  // function checkPermission(
  //     currentPermissions: PermissionName[],
  //     requiredPermission: PermissionName | PermissionName[],
  // ): boolean {
  //     let isPermitted: boolean;
  //     console.log(requiredPermission);

  //     isPermitted =
  //         requiredPermission &&
  //         validateRequiredPermissions(
  //             requiredPermission,
  //             PermissionCheckType.All,
  //             currentPermissions,
  //         );
  //     return isPermitted;
  // }
}
